(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');

  if (mobileMenuToggle && mobileMenuOverlay) {
    const spans = mobileMenuToggle.querySelectorAll('span');

    const toggleMenu = () => {
      const isClosed = !mobileMenuOverlay.classList.contains('flex');

      if (isClosed) {
        spans[0].style.transform = 'translateY(7px) rotate(45deg)';
        spans[1].style.opacity = '0';
        spans[1].style.transform = 'scaleX(0)';
        spans[2].style.transform = 'translateY(-7px) rotate(-45deg)';

        mobileMenuOverlay.classList.add('flex');
        mobileMenuOverlay.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
        mobileMenuToggle.setAttribute('aria-expanded', 'true');
      } else {
        spans[0].style.transform = 'none';
        spans[1].style.opacity = '1';
        spans[1].style.transform = 'none';
        spans[2].style.transform = 'none';

        mobileMenuOverlay.classList.add('hidden');
        mobileMenuOverlay.classList.remove('flex');
        document.body.style.overflow = '';
        mobileMenuToggle.setAttribute('aria-expanded', 'false');
      }
    };

    mobileMenuToggle.addEventListener('click', toggleMenu);
  }

  const closeRibbonBtn = document.getElementById('close-ribbon');
  const ribbonEl = document.getElementById('header-ribbon');
  const headerEl = document.getElementById('site-header');

  const RIBBON_CLOSED_KEY = 'joyful-ribbon-closed';

  if (closeRibbonBtn && ribbonEl) {
    const isRibbonClosed = localStorage.getItem(RIBBON_CLOSED_KEY) === 'true';

    if (isRibbonClosed) {
      ribbonEl.style.display = 'none';
      ribbonEl.classList.add('hidden');
    }

    closeRibbonBtn.addEventListener('click', () => {
      ribbonEl.style.display = 'none';
      ribbonEl.classList.add('hidden');
      localStorage.setItem(RIBBON_CLOSED_KEY, 'true');
      if (headerEl) {
        document.body.style.paddingTop = `${headerEl.offsetHeight}px`;
      }
    });
  }

  if (headerEl) {
    const updateHeaderAndRibbon = () => {
      const headerHeight = headerEl.offsetHeight;

      if (ribbonEl && ribbonEl.style.display !== 'none' && !ribbonEl.classList.contains('hidden')) {
        ribbonEl.style.top = `${headerHeight}px`;
        const ribbonHeight = ribbonEl.offsetHeight;
        document.body.style.paddingTop = `${headerHeight + ribbonHeight}px`;
      } else {
        document.body.style.paddingTop = `${headerHeight}px`;
      }
    };

    updateHeaderAndRibbon();
    window.addEventListener('resize', updateHeaderAndRibbon);

    // Also update if ribbon is loaded after initial calculation
    if (ribbonEl) {
      const observer = new ResizeObserver(updateHeaderAndRibbon);
      observer.observe(ribbonEl);
      observer.observe(headerEl);
    }
  }

  const languageButtons = document.querySelectorAll('.js-language-toggle');
  languageButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const targetUrl = button.getAttribute('data-language-url');

      if (targetUrl) {
        window.location.href = targetUrl;
      }
    });
  });

  if (headerEl) {
    const updateHeaderBackground = () => {
      const isScrolled = window.scrollY > 50;

      if (ribbonEl && ribbonEl.style.display !== 'none' && !ribbonEl.classList.contains('hidden')) {
        if (isScrolled) {
          ribbonEl.style.backgroundColor = 'rgba(191, 255, 0, 0.9)';
        } else {
          ribbonEl.style.backgroundColor = '#BFFF00';
        }
      }
    };

    document.addEventListener('scroll', updateHeaderBackground, { passive: true });
    updateHeaderBackground();
  }

  } catch(e) { console.error(e); }
})();
})();
